module.exports = __webpack_public_path__ + "static/media/4.efc72bf5.jpeg";